export default {
    data () {
        return {
            logoHeight: 0,
            checkLogoHeightCallback: null,
            lastUrl: null
        }
    },

    mounted () {
        window.addEventListener('resize', this.onResize)
    },

    beforeDestroy () {
        window.removeEventListener('resize', this.onResize)
    },

    methods: {
        onResize (event) {
            this.checkLogoHeight(this.lastUrl)
        },

        checkLogoHeight (url) {
            if (url == null) {
                return
            }
            this.lastUrl = url

            let image = new Image()
            image.src = url

            image.onload = () => {
                let logoElm = document.getElementById('logo')
                this.logoHeight = logoElm.offsetHeight
                
                if (this.checkLogoHeightCallback) {
                    this.checkLogoHeightCallback()
                }
            }
        },
    }
}